import http from "../../http-common";

class ProductRightSideNewsService {
    getProductRightSideNewsService(productPath: string) {
        return http.get(`/right-side-section/products/${productPath}?topN=2`);
    }
}

export default new ProductRightSideNewsService();
